<template>
  <div id="home">
    <Title :title="'Report inquery'"></Title>
    <div class="report">
      <div class="item" v-for="item in data" :key="item">
        <div>
          <div class="label">{{ $t("message.strid9") }}:</div>
          <span>{{ item.violation_time }}</span>
        </div>
        <div>
          <div class="label">{{ $t("message.strid10") }}:</div>
          <span>{{ item.nickname }}</span>
        </div>
        <div>
          <div class="label">{{ $t("message.strid11") }}:</div>
          <span>{{ item.reason }}</span>
        </div>
        <div>
          <div class="label">{{ $t("message.strid12") }}:</div>
          <span
            :class="item.violation_result == 0 ? 'accepted' : 'violation'"
            >{{$t('message.'+violation_result[item.violation_result])  }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { violationList ,getCode} from "@/proxy/index";
import Title from "@/components/Title";

export default {
  components: {
    Title,
  },
  created() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  data() {
    return {
      languageList: ["en"],
      inviteCode: "invite",
      showMask: false,
      data: [],
      violation_result: {
        0: "strid13",
        1: "strid14",
      },
      errCode: {},
    };
  },
  mounted() {
    document.querySelector("#loadingMask").style.display = "none";
    //取消请求
    this.getList();
    this.getCode();
  },
  methods: {
    getCode(lang) {
      getCode(window.localStorage.getItem("selfservicelang")).then((res) => {
        (res.data.errcode || []).map((item) => {
          this.errCode[item.code] = item.lang || "";
        });
      });
    },
    getList() {
      violationList(
        window.localStorage.getItem("selfservicelang"),
        Cookies.get("token")
      ).then((res) => {
        if (res.data.code == 0) {
          this.data = res.data.data;
        } else if (res.data.code == -20020) {
          Cookies.remove("token");
          this.$router.push({
            path: "home",
          });
        } else {
          layer.open({
            content: this.errCode[res.data.code] || res.data.code,
            skin: "msg",
            time: 2,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/views/appeal.scss";
</style>
